import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { BasicLineService } from './basic-line.service';
import { CommonService } from '../../service/common.service';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ChangeFilter } from '../../change-filter'
import { BasicLineChartParam, axisLabelRotate } from './basic-line-interface'
import { ECharts } from 'echarts';
import { initOpts } from '../../config/initOpts';
import { cloneDeep } from 'lodash';
import { da } from 'date-fns/locale';
import { ChartResizeService } from '../../service/chart-resize.service';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';
@Component({
  selector: 'bcac-basic-line',
  templateUrl: './basic-line.component.html',
  styleUrls: ['./basic-line.component.scss']
})

export class BasicLineComponent implements OnInit {

  constructor(
    private basicLineService: BasicLineService,
    private commonService: CommonService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService

  ) { }

  chartOption: any = this.basicLineService.getDefaultOpitonsOfBasicLineChart()

  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "图表标题"
  };

  // 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }
  // 标题文字
  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
  }
  // 表格文件名
  public _bcacChartFileName = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }

  // 是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.basicLineService.changeToolboxShow(this.chartOption, show)
    // this.updateOption()
  }

  // 输入是否显示图例
  @Input()
  set bcacChartShowLegend(bcacLegendShow: boolean) {
    this.basicLineService.changeLegendShow(this.chartOption, bcacLegendShow);
    this.updateOption();
  }

  public _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacTooltipUnit(tooltipUnit: string) {
    this.basicLineService.changeTooltipUnit(this.chartOption, tooltipUnit);
  }
  // x轴名称
  @Input()
  set bcacXAxisName(bcacXaxisName: string) {
    this.basicLineService.changeXAxisName(this.chartOption, bcacXaxisName)
    this.updateOption()
  }
  // y轴名称
  @Input()
  set bcacYAxisName(bcacYaxisName: string) {
    this.basicLineService.changeYAxisName(this.chartOption, bcacYaxisName)
    this.updateOption();
  }
  // y轴名称距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number) {
    this.basicLineService.changeYAxisNameGap(this.chartOption, yAxisNameGap)
    this.updateOption();
  }
  // x轴刻度标签旋转
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.basicLineService.changeXAxisLabelRotate(this.chartOption, xAxisLabelRotate);
    this.updateOption();
  }
  // y轴刻度标签旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.basicLineService.changeYAxisLabelRotate(this.chartOption, yAxisLabelRotate);
    this.updateOption();
  }
  // y轴最小刻度间隔
  @Input()
  set bcacYAxisMinInterval(yAxisInterval: number) {
    this.basicLineService.changeYAxisMinInterval(this.chartOption, yAxisInterval)
  }
  // y轴label的最大值
  @Input()
  set bcacYAxisMax(yAxisMax: number) {
    this.basicLineService.changeYAxisMax(this.chartOption, yAxisMax);
  }
  // y轴label的最小值
  @Input()
  set bcacYAxisMin(yAxisMin: number) {
    this.basicLineService.changeYAxisMin(this.chartOption, yAxisMin);
  }
  // y轴间隔
  @Input()
  set bcacYAxisInterval(yAxisInterval: number) {
    this.basicLineService.changeYAxisInterval(this.chartOption, yAxisInterval);
  }

  legendDataArr = [];
  bcacData;
  isNotSingleData: boolean = false;
  @Input()
  set bcacChartData(data: BasicLineChartParam) {
    this.bcacData = data;
    let legendDataArr = [];
    if (data && data.hasOwnProperty('seriesName')) {
      data.seriesNames.forEach(e => {
        legendDataArr.push(
          {
            label: e,
            value: e,
            checked: true
          }
        );
      });
    }
    this.legendDataArr = legendDataArr;
    this.basicLineService.changeChartData(this.chartOption, data);
    // if (this.isDarkMode === true) {
    //   this.chartDarkModeService.openDarkMode(this.chartOption, this.isDarkMode);
    // }
    this.updateOption();
  }

  legendChange(e) {
    this.basicLineService.topLegendChange(e, this.echartInstance);
  }

  @Output()
  bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter()

  @Output() bcacChartMouseOver: EventEmitter<any> = new EventEmitter()

  @Output() bcacChartClick: EventEmitter<any> = new EventEmitter();
  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.echartInstance, this.chartOption);
    })

  }

  updateOption() {
    if (this.echartInstance) {
      this.echartInstance.setOption(this.chartOption, true)
    }
  }

  echartInstance: ECharts;
  onOptionInit(ec) {
    this.echartInstance = ec;
    this.bcacGetChartInstance.emit(ec)
  }
  // mouseOver事件
  chartMouseOver(event) {
    this.bcacChartMouseOver.emit(event);
  }
  // 点击事件
  chartClick($event) {
    this.bcacChartClick.emit($event);
  }

  selectedData: any = '';

  dataSourceList: any = [];

  modelChange($event) {
    this.bcacData.forEach(element => {
      if (element.name === $event) {
        this.basicLineService.changeChartData(this.chartOption, element.data);
        this.updateOption();
        return;
      }
    });
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  intervalDatas = [];
  singleSelectIconShow: boolean = false;
  @Input()
  set bcacIntervalDatas(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalDatas = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }
  intervalSelectedData;
  axisScaleChange(e: any) {
    this.basicLineService.setInterval(this.chartOption, e);
    this.updateOption();
  }

  legendPosition = "bottom"; // bottom  right top none
  @Input()
  set bcacLegendPosition(value: string) {
    this.legendPosition = value;
    this.basicLineService.setLegendPosition(this.chartOption, this.legendPosition);
    this.updateOption();
  }

  customToolBoxRightPosition = "3.5rem";
  @Input()
  set bcacCustomToolBoxRightPosition(value: string) {
    this.customToolBoxRightPosition = value;
  }

  cardBgColor = "#fff";
  @Input()
  set bcacCardBgColor(value: string) {
    this.cardBgColor = value;
  }

  cardPadding = "1rem";
  @Input()
  set bcacCardPadding(type: string) {
    // default or none
    if (type === "none") {
      this.cardPadding = "0";
    }
  }

  @Input()
  set bcacChartBgColor(bgColor: string) {
    this.basicLineService.setChartBgColor(this.chartOption, bgColor);
    this.updateOption();
  }

  chartPaddingType = "default";  // default small
  @Input()
  set bcacChartPaddingType(value: string) {
    this.chartPaddingType = value;
    this.basicLineService.setChartPadding(this.chartOption, this.chartPaddingType, this.legendPosition);
    this.updateOption();
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding("0rem");
      this.chartResizeService.openSmallMode(this.chartOption, this.isSmallMode, this.legendPosition);
      // this.chartResizeService.configSplitLine(false, this.chartOption);
      this.updateOption();
    } else {
      this.isSmallMode = false;
    }
  }
  @Input()
  set bcacAxisSplitLine(axisSplitLineShow: boolean) {
    if (axisSplitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.chartOption)
    } else {
      this.chartResizeService.configSplitLine(false, this.chartOption)
    }
  }

  changeCardPadding(cardPadding: string) {
    this.cardPadding = cardPadding;
  }

  chartTitleColor = '';
  isDarkMode: boolean | string = false;
  @Input()
  set bcacDarkMode(darkMode: boolean | string) {
    this.isDarkMode = darkMode;
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.chartOption, darkMode);
  }

  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = color.darkModeTextColor;
    }
  }

  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }

  @Input()
  set bcacColors(chartColor: string[]) {
    this.commonService.changeChartColors(this.chartOption, chartColor)
  }
}
